export const accountTypeMixin = {
  methods: {
    userTypeMixin(accountType) {
      switch (accountType.toLowerCase()) {
        case 'admin':
          return {
            code: 12,
            type: accountType,
          };

        case 'recruiter':
          return {
            code: 11,
            type: accountType,
          };

        case 'manager':
          return {
            code: 2,
            type: accountType,
          };

        case 'user':
          return {
            code: 1,
            type: accountType,
          };

        case 'candidate':
          return {
            code: 0,
            type: accountType,
          };

        case 'root':
          return {
            code: 21,
            type: accountType,
          };

        default:
          return {
            code: '',
            type: '',
          };
      }
    },
    userCodeMixin(accountCode) {
      switch (accountCode) {
        case 12:
          return {
            code: accountCode,
            type: 'Admin',
          };

        case 11:
          return {
            code: accountCode,
            type: 'Recruiter',
          };

        case 2:
          return {
            code: accountCode,
            type: 'Manager',
          };

        case 1:
          return {
            code: accountCode,
            type: 'User',
          };

        case 0:
          return {
            code: accountCode,
            type: 'Candidate',
          };

        case 21:
          return {
            code: accountCode,
            type: 'Root',
          };

        default:
          return {
            code: '',
            type: '',
          };
      }
    },
  },
};
